"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const svgIcons_1 = require("../../../../svgIcons");
const react_redux_1 = require("react-redux");
const newsFeedSlice_1 = require("../../../../redux/slices/newsFeedSlice");
require("./comment.scss");
const avatar = require('../../../../assets/images/svg/no-photo.svg');
const Comment = (props) => {
    const { comment, newsId } = props;
    //@ts-ignore
    const [maxSymbols] = react_1.useState(window.innerWidth < 767 ? 160 : 300);
    const [showComment, setShowComment] = react_1.useState(false);
    return (react_1.default.createElement("div", { className: 'comment' },
        react_1.default.createElement("div", { className: 'comment-avatar' }, comment.avatar != null ? (react_1.default.createElement("img", { src: comment.avatar, alt: comment.name })) : (react_1.default.createElement("div", { className: 'default-avatar' },
            react_1.default.createElement("img", { src: avatar.default, alt: comment.name })))),
        react_1.default.createElement("div", { className: 'comment-info' },
            react_1.default.createElement("div", { className: 'name-data' },
                react_1.default.createElement("span", { className: 'name' }, comment.name),
                react_1.default.createElement("span", { className: 'date' }, moment_1.default(comment.created_at).format("MM/DD/YYYY"))),
            react_1.default.createElement("div", { className: 'single-comment' },
                comment.comment.length >= maxSymbols && !showComment ?
                    react_1.default.createElement(react_1.Fragment, null,
                        react_1.default.createElement("div", { className: 'comment-text long-next', id: `long-text-${comment.id}` },
                            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: comment.comment.replace(/\n/g, "<br />").substr(0, maxSymbols) } }),
                            "... ",
                            react_1.default.createElement("span", { className: 'read_more', onClick: () => setShowComment(true) }, " Read More"))) : react_1.default.createElement("div", { className: 'comment-text', dangerouslySetInnerHTML: { __html: comment.comment.replace(/\n/g, "<br />") } }),
                comment.myComment &&
                    react_1.default.createElement(svgIcons_1.DeleteMessageIcon, { onClick: () => {
                            props.toggleDeleteCommentModal();
                            props.getCommentDetails(comment.id, newsId);
                        }, className: `v2-delete-icon show-icon` })))));
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleDeleteCommentModal: () => dispatch(newsFeedSlice_1.toggleDeleteCommentModal()),
        getCommentDetails: (commentId, newsId) => dispatch(newsFeedSlice_1.getCommentDetails({ commentId: commentId, newsId: newsId })),
    };
};
exports.default = react_redux_1.connect(null, mapDispatchToProps)(Comment);
